import { assertNever } from "@p0security/frontend-core";
import { policyName } from "@p0security/integrations-aws-shared/util";
import { roleName } from "@p0security/integrations-gcloud-shared/util";
import {
  ALL_SCOPE_SENTINEL,
  ProviderOrAll,
} from "@p0security/shared/types/assessment";
import { Typography } from "@p0security/ui";
import { GraphTooltip } from "components/GraphTooltip";

import { HasAddTerm, ShowHideTerm } from "./ShowHide";

const awsLabel = (policyStatement: string | undefined) => {
  if (!policyStatement) return null;
  const [policy, statement] = policyStatement.split(":");
  return (
    <div className="flex flex-col">
      {policy}
      {statement && (
        <Typography.Text type="secondary">
          {isNaN(+statement) ? statement : `Statement ${statement}`}
        </Typography.Text>
      )}
    </div>
  );
};

const k8sLabel = (privilegeSet: string) => {
  const splitIndex = privilegeSet.lastIndexOf(":");
  const roleId = privilegeSet.substring(0, splitIndex);
  const ruleIndex = privilegeSet.substring(splitIndex + 1);
  return (
    <div className="flex flex-col">
      {roleId}
      <Typography.Text type="secondary">{`Rule ${ruleIndex}`}</Typography.Text>
    </div>
  );
};

export const privilegeSetName = (
  provider: ProviderOrAll,
  privilegeSet: string | undefined
) =>
  privilegeSet
    ? provider === "aws"
      ? awsLabel(policyName(privilegeSet))
      : provider === "gcp"
        ? roleName(privilegeSet)
        : provider === "k8s"
          ? k8sLabel(privilegeSet)
          : provider === "all" ||
              provider === "azure" ||
              provider === "azure-ad" ||
              provider === "entra-id" ||
              provider === "custom" ||
              provider === "okta" ||
              provider === "workspace"
            ? privilegeSet
            : assertNever(provider)
    : undefined;

export const PrivilegeSet: React.FC<
  {
    privilegeSet?: string;
    provider?: ProviderOrAll;
  } & HasAddTerm
> = ({ privilegeSet, provider, ...props }) => {
  const name = privilegeSetName(provider ?? ALL_SCOPE_SENTINEL, privilegeSet);
  return name ? (
    <GraphTooltip
      width="fit-content"
      title={
        <>
          {name}
          <ShowHideTerm
            term={`role:"${privilegeSet}"`}
            name="roles"
            {...props}
          />
        </>
      }
    >
      {name}
    </GraphTooltip>
  ) : null;
};
